export const GetEventTags = (competition, t) => {
    let tags = [...(competition._event?.tags || [])].filter((o) => o != 'inside' && o != 'online') // remove repeated type info

    const divisions = competition.divisions || []
    const hasTeam = divisions.some((o) => o.type == 'team')
    const hasSingle = divisions.some((o) => o.type == 'single')

    if (hasTeam) {
        tags.push(t('Team'))
    }
    if (hasSingle) {
        tags.push(t('Indiv'))
    }

    competition.tags = tags
    return competition
}
